import Vue from 'vue';
import VueGtm from 'vue-gtm';
import router from '@/router';

Vue.use(VueGtm, {
  id: 'GTM-P3X7D6R',
  enabled: process.env.NODE_ENV === 'production',
  router,
});
